import { render } from "./DFormControls.vue?vue&type=template&id=977e5838"
import script from "./DFormControls.vue?vue&type=script&lang=js"
export * from "./DFormControls.vue?vue&type=script&lang=js"

import "./DFormControls.vue?vue&type=style&index=0&id=977e5838&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__